import { getMonth, addMonths, startOfMonth, format, isAfter } from 'date-fns'
import { createSelector } from 'reselect'

const months = [
  'januar',
  'februar',
  'mars',
  'april',
  'mai',
  'juni',
  'juli',
  'august',
  'september',
  'oktober',
  'november',
  'desember',
]

const resultsSelector = createSelector(
  state => state.search.query,
  state => state.search.results,
  (query, results) => {
    try {
      return results[query]
    } catch (e) {
      return undefined
    }
  }
)

export const monthAvailabilitiesSelector = createSelector(
  resultsSelector,
  (results = []) =>
    Array(7)
      .fill(null)
      .map((_, index) => {
        const date = index
          ? startOfMonth(addMonths(new Date(), index))
          : new Date()
        return {
          month: index ? months[getMonth(addMonths(new Date(), index))] : 'nå',
          date: format(date, 'YYYY-MM-DD'),
          count: results.filter(
            consultant =>
              consultant.availability &&
              (consultant.availability.type === 'now' ||
                (consultant.availability.type === 'date' &&
                  !isAfter(consultant.availability.date, date)))
          ).length,
        }
      })
      .concat([
        {
          month: 'Vis alle',
          count: results.length,
        },
      ])
)



// WEBPACK FOOTER //
// ./src/selectors/monthAvailabilities.js